import { hiddenDown, hiddenUp } from '@twistopayments/design-system/styles'

import type { SectionsPricingPlanComponent } from '@twisto/api-cms'

import { Headline, Text } from 'homepage/components/article-components'
import { Box } from 'homepage/components/atoms'
import {
  PricingTable,
  PricingTableMobile,
} from 'homepage/components/molecules/pricing-table'

import * as styles from './pricing-plan.styles'

export const PricingPlan = ({
  headline,
  label,
  features,
  plans,
  featureHeadline,
  hintLabel,
  boxes,
}: SectionsPricingPlanComponent) => {
  if (!features || !plans) {
    return null
  }

  return (
    <section css={styles.container}>
      <div css={styles.headlineWrapper}>
        <Text color="primary" fontWeight="heavy" text={label} />
        <Headline name={headline} tag="h2" />
      </div>

      <PricingTable
        features={features}
        headline={featureHeadline ?? ''}
        plans={plans}
        tableCSS={hiddenDown('sm')}
        tooltipLabel={hintLabel ?? ''}
      />

      <div css={hiddenUp('smMd')}>
        <PricingTableMobile features={features} plans={plans} />
      </div>

      <div css={styles.boxes}>
        {boxes?.map((box) => <Box key={box.id} {...box} />)}
      </div>
    </section>
  )
}
